import { Subscription } from 'rxjs';
import { Injectable, OnDestroy, OnInit } from '@angular/core';

@Injectable()
export abstract class SubscribeComponent implements OnInit, OnDestroy {
  protected subscription$ = new Subscription();

  public abstract ngOnInit(): void;

  public ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
